import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    signedIn: localStorage.getItem("account") != null
  },
  mutations: {
    login(state) {
      state.signedIn = true;
    },
    logout(state) {
      state.signedIn = false;
      localStorage.removeItem("account")
      localStorage.removeItem("token")
      localStorage.removeItem("refresh_token")
    }
  },
  actions: {
  },
  modules: {
  }
})
